var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M18 15L12 9L6 15","stroke":"currentColor","stroke-width":"2","stroke-linecap":"square"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }